export function portalEventRegistrationPath(slug: string, eventUuid: string, occurrenceUuid: string): string {
  const query = new URLSearchParams({event: eventUuid, occurrence: occurrenceUuid});
  return `/${encodeURIComponent(slug)}/event-registration?${query}`;
}

const UUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function eventRegistrationUuid(value: unknown): string {
  return typeof value === "string" && UUID_PATTERN.test(value) ? value : "";
}
